import { keepPreviousData, useQuery } from "@tanstack/react-query";
import fetchWrapper from "../../api/fetchWrapper";
import { ENDPOINT } from "../../api/endpoint";
import { DashboardData, DashboardFilters } from "./types";

const useGetDashboardData = (filters: DashboardFilters) =>
  useQuery<DashboardData>({
    queryKey: ["dashboardData", filters],
    queryFn: () =>
      fetchWrapper(ENDPOINT.GET_DASHBOARD_DATA, {
        method: "POST",
        body: filters,
      }),
    placeholderData: keepPreviousData,
    staleTime: 10 * 60 * 1000,
    gcTime: 15 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: false,
  });

export default useGetDashboardData;
